var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanFillBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25214 7.43577L6.54875 4.32849C8.03327 2.31996 8.77553 1.31569 9.46805 1.52791C10.1606 1.74013 10.1606 2.97187 10.1606 5.43534V5.66761C10.1606 6.55614 10.1606 7.0004 10.4445 7.27906L10.4595 7.2935C10.7495 7.56627 11.2119 7.56627 12.1367 7.56627C13.8008 7.56627 14.6329 7.56627 14.9141 8.07098C14.9188 8.07934 14.9233 8.08776 14.9277 8.09625C15.1932 8.60877 14.7114 9.2606 13.7478 10.5643L11.4512 13.6715C9.96668 15.68 9.2244 16.6843 8.53188 16.4721C7.83936 16.2599 7.83938 15.0281 7.83941 12.5646L7.83942 12.3324C7.83943 11.4439 7.83944 10.9996 7.55553 10.721L7.54051 10.7065C7.25048 10.4338 6.78809 10.4338 5.86332 10.4338C4.19916 10.4338 3.36709 10.4338 3.08587 9.92905C3.08122 9.92069 3.07669 9.91227 3.07229 9.90378C2.80683 9.39126 3.2886 8.73943 4.25214 7.43577Z",
    fill: "#057EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanFillBlue);
export default __webpack_public_path__ + "static/media/icon_plan_fill_blue.c7125630c8ef52fbacf571cd77614a04.svg";
export { ForwardRef as ReactComponent };